<template>
  <Navbar />
  <div class="main_section">
    <div class="title col">
      <h1>
        交還入庫作業
      </h1>
    </div>
    <div class="info_wrap col">
      <!-- 申請人員，申請日期 -->
      <div class="fixed_info">
        <p>申請資訊</p>
      </div>
      <div class="content">
        <!-- 單號 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              單號：
            </div>
            <div class="form-control readonly_box">{{ Form.RR_ID }}</div>
          </div>
        </div>
        <!-- 接收人員 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              接收人員：
            </div>
            <div class="form-control readonly_box">{{ Form.ReturnPersonName }}</div>
          </div>
        </div>
        <!-- 交還日期 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              交還日期：
            </div>
            <div class="form-control readonly_box">{{ Form.ReturnDate }}</div>
          </div>
        </div>
        <!-- 交還人員 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">交還人員：</div>
            <div class="form-control readonly_box">{{ Form.CustodianName }}</div>
          </div>
        </div>
        <!-- 交還原因 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">交還原因：</div>
            <div class="form-control readonly_box">{{ Form.Reason }}</div>
          </div>
        </div>
        <!-- 備註 -->
        <div class="col-12">
          <div class="input-group d-flex">
            <div class="input-group-prepend">備註：</div>
            <textarea style="height: 200px;" class="form-control readonly_box" readonly maxlength="500"
              v-model="Form.Memo"></textarea>
          </div>
        </div>
        <!-- 已上傳文件 -->
        <div class="col-12 selected_file">
          <div class="input-group mt-3">
            <div class="input-group-prepend">已上傳文件：</div>
            <div class="file_upload_box">
              <div v-for="(file, index) in Form.existDocument" :key="index" class="file_upload_wrap mb-1">
                <p>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file)" data-bs-toggle="modal" data-bs-target="#viewFile_modal">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fixed_info mt-4">
        <p>資產點交清冊</p>
      </div>
      <div class="content assetList">
        <!-- 套用區域 -->
        <div class="d-flex flex-column gap-3"
          style="padding: 20px 50px; border-radius: 5px; background-color: #528091;">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="d-flex align-items-start align-items-md-center flex-column flex-md-row">
                <label class="input-title m-md-0 mb-1">歸還區域：</label>
                <select class="form-select flex-1" v-model="allApply.Area_Id"
                  @change="async () => { DropdownArray.Layer = await apiStore.getLayer(allApply.Area_Id); allApply.Layer_Id = '' }">
                  <option value="">--請選擇--</option>
                  <option v-for="option in DropdownArray.Area" :value="option.Id">{{ option.Name }}</option>
                </select>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-4 mt-md-0">
              <div class="d-flex align-items-start align-items-md-center flex-column flex-md-row">
                <label class="input-title m-md-0 mb-1">歸還櫃位：</label>
                <select class="form-select flex-1" v-model="allApply.Layer_Id">
                  <template v-if="DropdownArray.Layer.length > 0">
                    <option value="">--請選擇--</option>
                    <option v-for="option in DropdownArray.Layer" :value="option.Id">{{ option.Name }}</option>
                  </template>
                  <option value="">--請先選擇區域--</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 mt-2 mt-md-0">
              <div class="d-flex align-items-start align-items-md-center flex-column flex-md-row">
                <label class="input-title m-md-0 mb-1">入庫日期：</label>
                <input type="date" class="form-control flex-1" v-model="allApply.InBoundDate">
              </div>
            </div>
            <div class="col-12 col-md-6 mt-4 mt-md-0">
              <div class="d-flex h-100 justify-content-end align-items-center">
                <button type="button" class="mbtn main-5 btn_font" @click="applyAllTab">一鍵套用</button>
              </div>
            </div>
          </div>
        </div>
        <!-- 頁籤 -->
        <div v-show="tabData.length > 0" class="tab_section mt-5">
          <!-- tab頂端頁籤 -->
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button v-for="(tab, index) in tabData" :key="tab"
                :class="['nav-link', { active: index + 1 === 1 }, { warn: !tab.IsReturn }]" data-bs-toggle="tab"
                :data-bs-target="'#tab' + (index + 1)" type="button" role="tab">{{ index + 1 }}</button>
            </div>
          </nav>
          <!-- tab內容 -->
          <div class="tab-content" id="nav-tabContent">
            <div v-for="(tab, index) in tabData" :key="index"
              :class="['tab-pane', 'fade', { 'show active': index === 0 }]" :id="'tab' + (index + 1)" role="tabpanel">
              <!-- 是否已交還、 入庫日期 -->
              <div class="row g-0">
                <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                  <div class="input-group mb-3" id='number'>
                    <div class="input-group-prepend">是否已交還 :</div>
                    <div class="d-flex gap-3">
                      <div class="d-flex align-items-center gap-2">
                        <input type="radio" class="form-check-input m-0" name="" id="" value="true"
                          v-model="tab.IsReturn" :disabled="tab.IsReturn != true">
                        <label for="" class="form-check-label input-text">是</label>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <input type="radio" class="form-check-input m-0" name="" id="" value="false"
                          v-model="tab.IsReturn" :disabled="tab.IsReturn != false">
                        <label for="" class="form-check-label input-text">否</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                  <div class="input-group mb-3" id='unit'>
                    <div class="input-group-prepend"><span>*</span>入庫日期 :</div>
                    <input v-if="tab.IsReturn" class="form-control" type="date" v-model="tab.InBoundDate">
                    <input v-else class="form-control readonly_box" type="text" readonly>
                  </div>
                </div>
              </div>
              <!-- 頁籤資產編號 -->
              <div class="col">
                <div class="input-group mb-3">
                  <div class="input-group-prepend ">資產編號 :</div>
                  <div class="d-flex  search_section gap-2 flex-1">
                    <input type="text" class="form-control readonly_box flex-1" readonly v-model="tab.AssetsId">
                    <router-link :to="{name: 'Assets_View', query:{search_id: tab.AssetsId}}"><button class="h-100 mbtn main-5 btn_font">檢視</button></router-link>
                  </div>
                </div>
              </div>
              <!-- 頁籤物品名稱 -->
              <div class="col">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">物品名稱 :</div>
                  <input type="text" class="form-control readonly_box" readonly v-model="tab.AssetName">
                </div>
              </div>
              <!-- 頁籤資產狀態 -->
              <div class="col">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">資產狀態 :</div>
                  <input type="text" class="form-control readonly_box" readonly v-model="tab.Status">
                </div>
              </div>
              <!-- 頁籤廠商 -->
              <div class="col">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    廠商 :
                  </div>
                  <input type="text" class="form-control readonly_box" readonly v-model="tab.VendorName">
                </div>
              </div>
              <!-- 頁籤規格 -->
              <div class="col">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    規格 :
                  </div>
                  <input type="text" class="form-control readonly_box" readonly v-model="tab.ProductSpec">
                </div>
              </div>
              <!--頁籤型號 -->
              <div class="col">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">型號 :</div>
                  <input type="text" class="form-control readonly_box" readonly v-model="tab.ProductType">
                </div>
              </div>
              <!-- 頁籤 歸還區域 & 歸還櫃位 (only耗材) -->
              <div class="row g-0 row_wrap">
                <div class="col-xl-6 col-12">
                  <div class="input-group mb-3" id='number'>
                    <div class="input-group-prepend"><span>*</span>歸還區域 :</div>
                    <select v-if="tab.IsReturn" class="form-select flex-1" v-model="tab.Area_Id"
                      @change="async () => { tab.LayerOptions = await apiStore.getLayer(tab.Area_Id); tab.Layer_Id = '' }">
                      <option value="">--請選擇--</option>
                      <option v-for="option in DropdownArray.Area" :value="option.Id">{{ option.Name }}</option>
                    </select>
                    <input v-else class="form-control readonly_box" type="text" readonly v-model="tab.AreaName">
                  </div>
                </div>
                <div class="col-xl-6 col-12">
                  <div class="input-group mb-3" id='unit'>
                    <div class="input-group-prepend"><span>*</span>歸還櫃位 :</div>
                    <select v-if="tab.IsReturn" class="form-select flex-1" v-model="tab.Layer_Id">
                      <template v-if="tab.LayerOptions?.length > 0">
                        <option value="">--請選擇--</option>
                        <option v-for="option in tab.LayerOptions" :value="option.Id">{{ option.Name }}</option>
                      </template>
                      <option value="">--請先選擇區域--</option>
                    </select>
                    <input v-else class="form-control readonly_box" type="text" readonly v-model="tab.LayerName">
                  </div>
                </div>
              </div>
              <!-- 頁籤 數量 & 單位 -->
              <div class="row g-0 row_wrap">
                <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                  <div class="input-group mb-3" id='number'>
                    <div class="input-group-prepend">數量 :</div>
                    <input class="form-control readonly_box" type="text" v-model="tab.Number" readonly>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                  <div class="input-group mb-3" id='unit'>
                    <div class="input-group-prepend">單位 :</div>
                    <input class="form-control readonly_box" type="text" v-model="tab.Unit" readonly>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col button_wrap mt-4 gap-3">
        <button class="back_btn" @click="utilsStore.goBack">回上一頁</button>
        <button class="send_btn" @click="submit">確認入庫</button>
      </div>
    </div>
  </div>
  <view_modal></view_modal>
</template>

<script setup>
import view_modal from '@/components/view_modal.vue';
import { onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import Navbar from '@/components/Navbar.vue';
import { useAPIStore, useUtilsStore } from '@/store';
import { storeToRefs } from 'pinia';
import { useReturnAssetStore } from '@/store/return_asset/_index';
import { useRoute, useRouter } from 'vue-router';
import axios from "@/axios/tokenInterceptor";
import { Return_Asset_InBound } from '@/assets/js/enter_status';
const utilsStore = useUtilsStore();
const returnAssetStore = useReturnAssetStore();
const apiStore = useAPIStore();
const route = useRoute();
const router = useRouter();
const RR_ID = route.query.search_id
const {
  Form,
  DropdownArray
} = storeToRefs(returnAssetStore);

const allApply = reactive({
  Area_Id: '',
  Layer_Id: '',
  InBoundDate: '',
})

const applyAllTab = async () => {
  for (const tab of tabData.value) {
    if (tab.IsReturn) {
      tab.Area_Id = allApply.Area_Id;
      tab.InBoundDate = allApply.InBoundDate;
      tab.Layer_Id = allApply.Layer_Id;
    }
  }
  setTabLayer();
}
/**
 * 更新 tabData 裡面的所有櫃位選項
 */
const setTabLayer = async () => {
  for (const tab of tabData.value) {
    tab.LayerOptions = await apiStore.getLayer(tab.Area_Id);
  }
}
const tabData = ref([])
/**
 * 檢查已交還的物品是否都已經填寫所有欄位
 * @return {Boolean} Pass: true, Invalid: false
 */
const checkRequired = () => {
  let invalidList = [];
  tabData.value.forEach((tab)=>{
    if(tab.IsReturn) {
      if(!tab.Area_Id || !tab.Layer_Id || !tab.InBoundDate) invalidList.push(tab.AssetsId)
    }
  })
  if(invalidList.length > 0) {
    alert(`資產編號:${invalidList.join('、')}尚有未填項目`);
    return false
  }
  return true
}
const submit = async () => {
  // checkRequired
  if(!checkRequired()) return
  let requestData = {
    RR_ID: RR_ID,
    AssetInfoList: []
  }
  tabData.value.forEach((tab) => {
    requestData.AssetInfoList.push({
      InBoundDate: tab.InBoundDate,
      IsReturn: tab.IsReturn,
      AssetsId: tab.AssetsId,
      Area_Id: tab.Area_Id,
      Layer_Id: tab.Layer_Id,
    })
  })
  try {
    const response = await axios.post(`/ReturnAssetMng/AssetsIn`, requestData);
    const data = response.data;
    if (data.state === "success") {
      alert(data.message + "\n單號:" + RR_ID);
      router.push({ name: "Return_Asset_Datagrid" });
    } else {
      alert(data.message);
    }
  } catch (e) {
    console.error(e);
  }
}
const searchAssetList = async () => {
  tabData.value = [];
  let assetData = [];
  if (Form.value.TotalNum > 200) {
    const count = Math.ceil(Form.value.TotalNum / 200);
    for (let i = 1; i <= count; i++) {
      assetData = await returnAssetStore.getCustodianAssetList(Form.value.Custodian, RR_ID, true, '200', i);
      assetData.Area_Id = '';
      assetData.Layer_Id = '';
      tabData.value.push(assetData);
    }
  } else {
    assetData = await returnAssetStore.getCustodianAssetList(Form.value.Custodian, RR_ID, true);
    for(let item of assetData) {
      item.Area_Id = '';
      item.Layer_Id = '';
    }
    tabData.value = assetData;
  }
  setTabLayer();
}
onMounted(async () => {
  returnAssetStore.$reset();
  await returnAssetStore.getDetails(RR_ID, Return_Asset_InBound);
  DropdownArray.value.Area = await apiStore.getArea();
  searchAssetList();
});


onUnmounted(() => {
  returnAssetStore.$dispose();
})

</script>


<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.input-title {
  color: white;
  font-size: 20px;
  font-weight: 700;
}

.input-text {
  color: white;
  font-size: 18px;
  font-weight: 700;
}

.view_icon,
.trash_icon {
  cursor: pointer;
}

.modal {
  .modal-body {
    padding: 20px;
    margin: auto;
  }

  .modal-content {
    margin: auto;
  }

  .modal-input-group-prepend {
    width: auto;
    font-weight: 700;
    font-size: 20px;
  }

  .modal-footer {
    padding: 0 12px 12px;
    border: none;
  }

  .modal-header {
    h5 {
      font-weight: 700;
    }

    background: #528091;
    color: white;
    display: flex;
    justify-content: center;
  }
}

.readonly_box {
  @include readonly_box;
}

.form_search_btn {
  @include form_search_btn;
}

.input-number {
  @include count_btn;
}

span {
  @include red_star;
}


.fixed_info {
  @include fixed_info;

  p {
    font-size: 20px;
    margin-bottom: 0;
  }
}

.content {
  @include content_bg;
}

.form-control,
.readonly_box {
  height: 37px;
  // border-radius: 0;
}

.input-group-prepend {
  color: white;
  font-weight: 700;
  font-size: 20px;
  width: 130px;
}

.file_wrap {
  display: flex;
  flex-direction: column;

  .choose_btn {
    margin-bottom: 10px;
    @include choose_file_btn;

    &:hover {
      background: #3f608f;
    }
  }
}

.selected_file {
  .file_upload_box {
    .file_upload_wrap {
      margin-bottom: 0;
      display: flex;
      word-break: break-word;

      img {
        width: 25px;
        height: 25px;
      }

      p {
        margin-bottom: 0;
        font-weight: 700;
        color: white;

        &::before {
          margin-right: 10px;
          content: "·";
          font-weight: 700;
          color: white;
        }
      }
    }
  }
}

.back_btn {
  @include back_to_previous_btn;

  &:hover {
    background-color: #5d85bb;
  }
}

.send_btn {
  @include search_and_send_btn;
  width: unset;

  &:hover {
    background-color: #5e7aa2;
  }
}

.send_btn_disabled {
  background: #878787;

  &:hover {
    background: #878787;
  }
}

.tab_section {
  .nav {
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    border: none;

    ::-webkit-scrollbar {
      height: 6px;
      border: 1px solid rgb(219, 218, 218);
      border-radius: 5px;
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      display: block;
      border-radius: 5px;
      background-color: rgb(176, 175, 175);
      border: 1px solid rgb(86, 85, 85);
    }
  }

  .nav-tabs {
    button {
      @include tab_section_num;
      background: #5c7897;
    }

    .warn:not(.active) {
      background: #E94B4B;
    }

    .active {
      @include tab_section_num;
      background: #3e4e5f;
    }
  }

  .tab-content {
    background: #3e4e5f;
    position: relative;
    padding: 20px 36px;
    border-radius: 0 5px 5px 5px;

    .check_box_wrap {
      font-weight: 700;
      color: white;
      font-size: 18px;
    }

    .dropdown {
      .dropdown-menu {
        width: 100%;
        max-height: 250px;
        overflow-y: auto;

        p {
          &:hover {
            cursor: pointer;
          }
        }
      }

      .dropdown-toggle {
        width: 100%;
        @include dropdown-btn;
        color: black;
        justify-content: space-between;
        align-items: center;
      }
    }

    .input-group {
      flex-wrap: nowrap;
    }
  }
}

@media only screen and (min-width: 1200px) {
  .main_section {
    .info_wrap {
      margin: 8px auto 5%;
      width: 800px;

      .content {
        .input-group {
          .input-group-prepend {
            text-align: end;
            width: 130px;
          }
        }
      }

      .selected_file {
        .input-group {
          flex-wrap: unset;
        }

        .input-group-prepend {
          white-space: nowrap;
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .main_section {
    .info_wrap {
      margin: 8px auto 5%;
      width: 750px;

      .content {
        .input-group {

          .readonly_box {
            width: 57%;
          }

          .input-group-prepend {
            text-align: end;
            width: 130px;
          }
        }
      }

      .selected_file {
        .input-group {
          flex-wrap: unset;
        }

        .input-group-prepend {
          white-space: nowrap;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .tab_section {
    .tab-content {
      padding: 50px 20px;
    }
  }

  .main_section {

    .search_section,
    .readonly_box,
    .input-number,
    .form-control,
    .form-select,
    .file_wrap {
      margin-left: unset !important;
    }

    .form_search_btn {
      border: none;
      color: white;
      width: 60px;
      height: 35px;
      margin-left: unset !important;
      margin-top: 10px;
      font-weight: 700;
      padding: 0 10px;
      background-color: #132238;

      &:hover {
        background-color: #43546d;
      }
    }

    .info_wrap {
      padding: 0 5%;

      .fixed_info {
        height: unset;
        flex-direction: column;
        padding: 10px;
      }

      .content {
        .input-group {
          flex-direction: column;

          .input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
            margin-left: unset;
            border-radius: 5px;
            margin-top: 5px;
            height: 35px;
          }

          .form-control,
          .form-select {
            width: 100%;
          }

          .input-group-prepend {
            margin-bottom: 5px;
            width: 100px;
            white-space: nowrap;
          }

          .file_wrap {
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>